import React from 'react';
import ProgressSlider from './ProgressSlider';
import './ProgressBar.css';

interface ProgressBarProps {
  /** Progress value from 0 to 100 */
  value: number;
  /** Optional label displayed next to the bar */
  label?: string;
  /** Show percentage text inside the bar */
  showPercentage?: boolean;
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Optional modifier for richer dashboard/review styling */
  variant?: 'default' | 'premium';
}

/**
 * ProgressBar Component
 * Displays a visual progress bar reflecting a 0-100 percentage value.
 * Requirements: 5.5
 */
const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  label,
  showPercentage = true,
  size = 'md',
  variant = 'premium',
}) => {
  const clampedValue = Math.round(Math.min(100, Math.max(0, value)));

  return (
    <div
      className={`pms-progress-bar pms-progress-bar--${size} pms-progress-bar--${variant}`}
      style={{ '--progress-value': `${clampedValue}%` } as React.CSSProperties}
    >
      <ProgressSlider
        value={clampedValue}
        label={label}
        size={size}
        showPercentage={showPercentage}
        readOnly
        ariaLabel={label || `Progress: ${clampedValue}%`}
      />
    </div>
  );
};

export default ProgressBar;
